var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "YouTube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33a16 16 0 1116-16 16 16 0 01-16 16z",
    fill: "#ffc212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.39 14.7a4.09 4.09 0 00-4.09-4.09H11.7a4.09 4.09 0 00-4.09 4.09v5a4.09 4.09 0 004.09 4.09h10.6a4.09 4.09 0 004.09-4.09zm-6.69 2.73l-4.23 2.32c-.18.1-.35 0-.35-.24v-4.76c0-.21.17-.35.36-.24L19.73 17a.27.27 0 01-.03.43z",
    fill: "#28414b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.4c7f52038c5d62fe2af57038367aec87.svg";
export { ForwardRef as ReactComponent };